<template>
  <div id="app">
    <Header></Header>
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import Header from "@/components/header";
export default {
  name: "App",
  components: { Header },
  created() {
      var citysearch = new AMap.CitySearch()
      let today = {}
      //自动获取用户IP，返回当前城市
      citysearch.getLocalCity(function (status, result) {
        today.location = result.city;
      });
      setTimeout(() => {
        localStorage.setItem("location", today.location)
      },500)
  }
};
</script>

<style>
@import "./common/font/font.css";
body {
  margin: 0;
  font-family: "kF";
}
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  width: 100%;
  height: 100%;
  /* background: #eeeff3; */
}
.containerBox {
  z-index: 99;
  position: relative;
}
.el-message__icon{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue